import { getStoreId } from "$/hooks/use-store-information"
import storeCustomerQueries from "$/lib/queries/store-customer-queries"
import { requireNonFreeTier } from "$/lib/require-non-free-tier"
import { createFileRoute } from "@tanstack/react-router"
import { DEFAULT_STORE_CUSTOMER_LIST_PARAMS } from "./-components/store-customer-columns"

export const Route = createFileRoute("/(app)/_auth/customers/")({
  loader: async ({ context: { queryClient } }) => {
    await requireNonFreeTier(queryClient)
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(
        storeCustomerQueries.list(storeId, DEFAULT_STORE_CUSTOMER_LIST_PARAMS),
      )
    }
    return {
      crumb: "alfred.pages.customers.crumbs.allCustomers",
    }
  },
})
